import { SILVERTIGER_LOCALE_COOKIE } from '@/const/locale';
import { LOCALE_STORAGE_KEY } from '@/utils/language-utils';
import { LocaleMode } from '@/types_cp/locale';

import { setCookie } from './cookie';

export const switchLangNextIntl = (locale: LocaleMode) => {
  const lang = locale === 'auto' ? navigator.language.split('-')[0] : locale;

  // Set the document language
  document.documentElement.lang = lang;

  // Set the document direction for RTL languages
  const rtlLanguages = ['ar', 'fa', 'he'];
  document.documentElement.dir = rtlLanguages.includes(lang) ? 'RTL' : 'LTR';

  // Save the locale preference to cookie for persistence
  setCookie(SILVERTIGER_LOCALE_COOKIE, locale === 'auto' ? undefined : locale, 365);
  setCookie(LOCALE_STORAGE_KEY, locale === 'auto' ? undefined : lang, 365);

  // Trigger a custom event to notify components about language change
  window.dispatchEvent(new CustomEvent('languageChanged', { 
    detail: { locale, lang } 
  }));

  // Force re-render of the page content by updating a data attribute
  // This helps trigger re-evaluation of translations
  document.documentElement.setAttribute('data-locale', lang);
};
